import React from 'react'
import PropTypes from "prop-types"
import { getDayOfTheWeekName } from '../../../../../../helpers/week'
import { capitalizeFirstLetter } from '../../../../../../helpers/string'

const DeliveryHoursTable = ({ data }) => {
  return <table className="table table-striped">
    <tbody>
      {data.map((row) =>  row.DeliveryTimeSlots.map((slot) => <tr key={row.DayOfWeek}>
        <td name="dayOfWeek">
          {row.DeliveryTimeSlots[0] === slot ? capitalizeFirstLetter(getDayOfTheWeekName(row.DayOfWeek)) : ""}
        </td>
        <td name="startTime" className={row.ClosedForTheDay ? 'lineThrough' : ''}>
          {slot.StartTime}
        </td>
        <td name="endTime" className={row.ClosedForTheDay ? 'lineThrough' : ''}>
          {slot.EndTime}
        </td>
        <td name="closedForTheDay">
          {row.DeliveryTimeSlots[0] === slot ? (row.ClosedForTheDay ? "Closed" : "Open") : ""}
        </td>
      </tr>)
      )}
    </tbody>
  </table>
}

DeliveryHoursTable.propTypes = {
  data: PropTypes.array
}

export default DeliveryHoursTable



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/deliveryHoursUpdated/deliveryHoursTable.js